var Text_module_default = {
	control: "_control_d83jn_10",
	"enable-ligatures": "_enable-ligatures_d83jn_63"
};
//#endregion
export { Text_module_default as default };

//# sourceMappingURL=Text.module.js.map